export default __webpack_public_path__ + "static/media/logo.c195b0cc.png";